(function () {
  'use strict';
  angular.module('obex').
  factory('alertService', ['$rootScope', '$http', 'smsStatus', 'authService',
    function ($rootScope, $http, smsStatus, authService) {
      return {
        getUnhandledAlerts() {
          var loginMember = authService.getLoginMember();
          //\\return $http.get('/unhandledAlerts/' + loginMember.OrganizationId);
          return $http({
            method: 'GET',
            url: '/unhandledAlerts/' + loginMember.OrganizationId + '/' + loginMember.Email,
            params: { 'foobar': new Date().getTime() }
          });
        },

        getHandledSms() {
          var loginMember = authService.getLoginMember();
          return $http.get('/handledSms/' + loginMember.Email);
        },
        getUnhandledVoiceAlerts() {
          const loginMember = authService.getLoginMember();
          return $http({
            method: 'GET',
            url: '/unhandledVoiceAlerts/' + loginMember.OrganizationId + '/' + loginMember.Email,
            params: { 'foobar': new Date().getTime() }
          });
        },
        getHandledPhone() {
          var loginMember = authService.getLoginMember();
          return $http.get('/handledPhone/' + loginMember.Email);
        },
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/alert.service.js